import { useState } from "react";
import { Link } from "react-router-dom";
import { FileText, PlusCircle, Sparkles, UploadCloud } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { UploadPolicyModal } from "@/components/policy/UploadPolicyModal";
import { useAuth } from "@/contexts/AuthContext";

const actions = [
  {
    title: "Create",
    description: "New policy",
    icon: PlusCircle,
    href: "/begin",
  },
  {
    title: "Upload",
    description: "Existing file",
    icon: UploadCloud,
    action: "upload",
  },
  {
    title: "AI Draft",
    description: "Use Polybot",
    icon: Sparkles,
    href: "/ai-agent",
  },
  {
    title: "Template",
    description: "Start faster",
    icon: FileText,
    href: "/templates",
  },
];

const QuickActions = () => {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const { hasAnyRole } = useAuth();

  if (!hasAnyRole(["creator", "admin"])) {
    return null;
  }

  return (
    <>
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-base font-semibold text-foreground">Utilities</CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-2 gap-2">
          {actions.map((action) => {
            const Icon = action.icon;
            const content = (
              <>
                <Icon className="h-4 w-4" />
                <span className="text-sm font-medium">{action.title}</span>
                <span className="text-[11px] font-normal text-muted-foreground">{action.description}</span>
              </>
            );

            if (action.action === "upload") {
              return (
                <Button
                  key={action.title}
                  type="button"
                  variant="outline"
                  className="h-auto flex-col items-start gap-1 p-3 text-left"
                  onClick={() => setShowUploadModal(true)}
                >
                  {content}
                </Button>
              );
            }

            return (
              <Button key={action.title} asChild variant="outline" className="h-auto justify-start p-0">
                <Link to={action.href ?? "/dashboard"} className="flex h-full w-full flex-col items-start gap-1 p-3 text-left">
                  {content}
                </Link>
              </Button>
            );
          })}
        </CardContent>
      </Card>

      <UploadPolicyModal open={showUploadModal} onOpenChange={setShowUploadModal} />
    </>
  );
};

export { QuickActions };
